import { render } from "./StoreItem.vue?vue&type=template&id=22451098&scoped=true"
import script from "./StoreItem.vue?vue&type=script&lang=js"
export * from "./StoreItem.vue?vue&type=script&lang=js"

import "./StoreItem.vue?vue&type=style&index=0&id=22451098&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22451098"]])

export default __exports__